import { sendResetPassword, setResetPasswordStatus } from "actions/user";
import SageButton from "kit/SageButton";
import SageErrorAlert from "kit/SageErrorAlert";
import SageScreen from "kit/SageScreen";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import sendResetPasswordStatusSelector from "selectors/sendResetPasswordStatus";

const SendResetPassword: React.FC = () => {
    const dispatch = useDispatch();
    const [email, setEmail] = React.useState("");
    const status = useSelector(sendResetPasswordStatusSelector);

    const onSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            dispatch(sendResetPassword(email));
        },
        [email, dispatch]
    );

    const onEmailInputChanged = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(e.target.value);
        },
        [setEmail]
    );

    const onDismissError = React.useCallback(() => {
        dispatch(setResetPasswordStatus("none"));
    }, [dispatch]);

    React.useEffect(() => {
        dispatch(setResetPasswordStatus("none"));
    }, [dispatch]);

    return (
        <SageScreen>
            <h1>Reset Password</h1>
            <p>
                Reset the password to your Rend A Hand account by entering your
                email below.
            </p>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label htmlFor="emailInput">Email Address</label>
                    <input
                        value={email}
                        onChange={onEmailInputChanged}
                        type="email"
                        className="form-control"
                        id="emailInput"
                    />
                </div>
                {status === "success" && (
                    <p className="text-success">
                        If the email you entered is correct, an email to reset
                        your email will be sent to the email address you listed.
                    </p>
                )}
                {status !== "success" && (
                    <SageButton
                        loading={status === "loading"}
                        text="Reset Password"
                        type="submit"
                    />
                )}
                {status === "error" && (
                    <SageErrorAlert
                        onDismiss={onDismissError}
                        text={"There was an error. Please try again."}
                    />
                )}
            </form>
        </SageScreen>
    );
};

export default SendResetPassword;
